import { defineMessage } from 'react-intl'


const FOIL_OPTIONS = [
    {
        label: defineMessage({ defaultMessage: "Ohne Folie" }),
        value: "no-foil",
        color: 'transparent'
    }, {
        label: defineMessage({ defaultMessage: "Gold" }),
        value: "gold",
        color: '#E2C312',
        default: true
    }, {
        label: defineMessage({ defaultMessage: "Silber" }),
        value: "silver",
        color: '#DEDEDE',
    }, {
        label: defineMessage({ defaultMessage: "Rose Gold" }),
        value: "rose-gold",
        color: '#E8B8B9'
    }
]

export default FOIL_OPTIONS